import React, { useEffect, useState } from "react";
import { 
  Table, 
  Button, 
  Input, 
  Container, 
  FormFeedback,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col
} from "reactstrap";
import { statusService, userService } from "services";

import LoaderBox from "../components/custom/loader/loaderBox";
import { useHistory } from "react-router-dom";
import useAuth from "hooks/useAuth";
import { useApi, useTable, useFormHandler } from "hooks";
import NotifyComponent, { showNotify } from "components/notifications/notify";
import { describeApiError } from "services/apiErrorMessage";

const NewStatus = ({ fetchStatus, notifyRef }) => {
  const [inputNew, setInputNew] = useState({
    state: false,
    colSpan: "2",
  });
  const [showConfirm, setShowConfirm] = useState(false);

  const enableNew = () => {
    setInputNew({ state: true, colSpan: "1" });
    form.reset();
  };
  const disableNew = () => {
    setInputNew({ state: false, colSpan: "2" });
    setShowConfirm(false);
  };

  const validate = (values) => {
    const formErrors = {};
    if (!values.name?.trim()) {
      formErrors.name = "Informe o nome do status";
    }
    return formErrors;
  };

  const form = useFormHandler(
    {
      name: "",
      description: "",
    },
    {
      validate,
    },
  );

  const createStatus = () => {
    const validationErrors = validate(form.values);
    if (Object.keys(validationErrors).length > 0) {
      form.setErrors(validationErrors);
      form.setTouched({ name: true, description: true });
      return;
    }
    setShowConfirm(true);
  };

  const confirmCreateStatus = form.handleSubmit(async (formValues, { reset }) => {
    const newStatus = {
      name: formValues.name,
      description: formValues.description,
    };

    try {
      await statusService.create(newStatus);
      await fetchStatus();
      setShowConfirm(false);
      setInputNew({ state: false, colSpan: "2" });
      reset();
    } catch (error) {
      console.error(error);
      const msg = describeApiError(error);
      showNotify(notifyRef, "Erro", msg, "danger");
    }
  });

  return (
    <tr className="bg-secondary-lighter">
      <td colSpan={inputNew.colSpan} className="py-3 px-4">
        {inputNew.state === true ? (
          <Row className="form-row align-items-center">
            <Col md="4">
              <Input
                placeholder="Nome do Status"
                bsSize="sm"
                type="text"
                {...form.register("name")}
                invalid={form.touched.name && Boolean(form.errors.name)}
                className="shadow-none border-0"
              />
              {form.touched.name && form.errors.name ? (
                <FormFeedback style={{ display: "block" }}>
                  {form.errors.name}
                </FormFeedback>
              ) : null}
            </Col>
            <Col md="8">
              <Input
                placeholder="Breve descrição do status..."
                bsSize="sm"
                type="text"
                {...form.register("description")}
                className="shadow-none border-0"
              />
            </Col>
          </Row>
        ) : (
          <div
            onClick={enableNew}
            className="px-3 py-2 border rounded text-muted bg-white cursor-pointer hover-shadow"
            style={{ borderStyle: 'dashed !important', fontSize: '0.9rem' }}
          >
            <i className="ni ni-fat-add mr-2" />
            Clique para adicionar um novo status...
          </div>
        )}
      </td>
      <td className="text-right py-3 px-4">
        {inputNew.state === true ? (
          <div className="d-flex justify-content-end align-items-center">
            {showConfirm ? (
              <Button
                color="success"
                size="sm"
                type="button"
                onClick={confirmCreateStatus}
                className="px-3"
              >
                Confirmar
              </Button>
            ) : (
              <Button
                color="primary"
                size="sm"
                type="button"
                onClick={createStatus}
                className="px-3"
              >
                Salvar
              </Button>
            )}
            <Button
              color="secondary"
              outline
              size="sm"
              type="button"
              onClick={disableNew}
              className="ml-2"
            >
              Cancelar
            </Button>
          </div>
        ) : null}
      </td>
    </tr>
  );
};

const ListItem = ({ post, fetchStatus }) => {
  const [editStatus, setEditStatus] = useState(false);
  const [confirmActivate, setConfirmActivate] = useState(false);
  const [confirmSave, setConfirmSave] = useState(false);
  const [editValues, setEditValues] = useState({ name: post.name, description: post.description || "" });
  const openEdit = () => {
    setEditValues({ name: post.name, description: post.description || "" });
    setEditStatus(true);
  };
  const closeEdit = () => setEditStatus(false);

  const [handleDelete, setHandlerDelete] = useState(false);
  const confirmDelete = () => setHandlerDelete(true);
  const closeDelete = () => setHandlerDelete(false);

  const deleteStatus = (id) => {
    statusService
      .update(id, { is_active: false })
      .then(() => {
        fetchStatus();
      })
      .catch(console.error);
  };

  const activeStatus = (id) => {
    statusService
      .update(id, { is_active: true })
      .then(() => {
        fetchStatus();
      })
      .catch(console.error);
  };

  const updateStatus = (e) => {
    e.target.disabled = true;

    statusService
      .update(post.id, editValues)
      .then(() => {
        e.target.disabled = false;
        setConfirmSave(false);
        setEditStatus(false);
        fetchStatus();
      })
      .catch((err) => {
        e.target.disabled = false;
        console.error(err);
      });
  };

  return (
    <tr className="hover-light">
      <th scope="row" className="px-4 py-3">
        {editStatus === true ? (
          <Input
            value={editValues.name}
            onChange={(e) => setEditValues({ ...editValues, name: e.target.value })}
            id={`updateName-${post.id}`}
            bsSize="sm"
            type="text"
            className="font-weight-bold"
          />
        ) : (
          <div className="d-flex align-items-center">
            <span className={`font-weight-700 ${post.is_active ? 'text-dark' : 'text-muted'}`} style={{ fontSize: '0.9rem' }}>
              {post.name}
            </span>
            {!post.is_active && (
              <span className="badge badge-dot ml-2">
                <i className="bg-danger" />
                <span className="status text-danger small">Desabilitado</span>
              </span>
            )}
          </div>
        )}
      </th>
      <td className="px-4 py-3">
        {editStatus === true ? (
          <Input
            value={editValues.description}
            onChange={(e) => setEditValues({ ...editValues, description: e.target.value })}
            id={`updateDescription-${post.id}`}
            bsSize="sm"
            type="text"
          />
        ) : (
          <span className="text-muted small">{post.description || "Sem descrição..."}</span>
        )}
      </td>
      <td className="text-right px-4 py-3">
        {handleDelete === false ? (
          <div className="d-flex justify-content-end">
            {editStatus === true ? (
              <>
                {confirmSave ? (
                  <Button
                    color="success"
                    onClick={updateStatus}
                    size="sm"
                    type="button"
                  >
                    Confirmar
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={() => setConfirmSave(true)}
                    size="sm"
                    type="button"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  color="link"
                  className="text-danger ml-2"
                  size="sm"
                  type="button"
                  onClick={closeEdit}
                >
                  Sair
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="secondary"
                  outline
                  onClick={openEdit}
                  size="sm"
                  type="button"
                  className="btn-icon-only border-0"
                  title="Editar"
                >
                  <i className="ni ni-settings" />
                </Button>
                {post.is_active === true ? (
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    type="button"
                    onClick={confirmDelete}
                    className="btn-icon-only border-0 text-danger"
                    title="Desabilitar"
                  >
                    <i className="ni ni-button-power" />
                  </Button>
                ) : (
                  <Button
                    color={confirmActivate ? "success" : "secondary"}
                    outline
                    size="sm"
                    type="button"
                    onClick={() => confirmActivate ? activeStatus(post.id) : setConfirmActivate(true)}
                    className="btn-icon-only border-0 text-success"
                    title="Ativar"
                  >
                    {confirmActivate ? "✓" : <i className="ni ni-check-bold" />}
                  </Button>
                )}
              </>
            )}
          </div>
        ) : (
          <Button
            color="danger"
            size="sm"
            type="button"
            onClick={() => deleteStatus(post.id)}
            className="px-3"
          >
            Confirmar Desativação
          </Button>
        )}
      </td>
    </tr>
  );
};

const ListStatus = () => {
  const {
    data: statusResponse,
    loading: loader,
    execute: fetchStatus,
  } = useApi(statusService.list);

  const {
    data: statusData,
    setData: setStatusData,
  } = useTable({ initialData: [] });

  const notifyRef = React.useRef(null);

  useEffect(() => {
    if (statusResponse) {
      setStatusData(statusResponse);
    }
  }, [setStatusData, statusResponse]);

  const history = useHistory();
  const { authorId, signOut } = useAuth();

  useEffect(() => {
    if (!authorId) {
      return;
    }

    const checkAdminPermission = async () => {
      try {
        const response = await userService.getById(authorId);
        const userData = response.data;

        if (!userData.is_superuser) {
          history.push("/admin");
        }
      } catch (error) {
        console.error("Erro ao verificar permissões do usuário:", error);
        signOut();
        history.push("/auth/login");
      }
    };

    checkAdminPermission();
  }, [authorId, history, signOut]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return (
    <div className="content">
      <NotifyComponent notifyRef={notifyRef} />
      <Container fluid>
        <Row className="mb-4 align-items-center">
          <Col>
            <h2 className="mb-0 text-dark" style={{ fontWeight: "700" }}>
              <i className="ni ni-tag text-primary mr-2" />
              Dicionário de Status
            </h2>
            <p className="text-muted mb-0 small">Gerencie as categorias e estágios dos processos registrados no sistema.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card className="shadow-sm border-0 overflow-hidden">
              <CardHeader className="bg-transparent border-0 py-3">
                <Row className="align-items-center">
                  <Col>
                    <h4 className="mb-0 text-muted font-weight-600">Lista Geral</h4>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="p-0">
                {loader ? (
                  <div className="py-5">
                    <LoaderBox />
                  </div>
                ) : (
                  <Table className="align-items-center table-flush mb-0" responsive>
                    <thead className="thead-light">
                      <NewStatus fetchStatus={fetchStatus} notifyRef={notifyRef} />
                      <tr>
                        <th scope="col" className="px-4 py-3 font-weight-bold text-uppercase ls-1">Nome</th>
                        <th scope="col" className="px-4 py-3 font-weight-bold text-uppercase ls-1">Descrição</th>
                        <th scope="col" className="px-4 py-3 text-right" style={{ width: "150px" }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusData.length > 0 ? (
                        statusData.map((post, index) => (
                          <ListItem key={`statuslist-${index}`} post={post} fetchStatus={fetchStatus} />
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center py-5">
                            <i className="ni ni-paper-diploma display-3 text-muted opacity-5 mb-3" />
                            <h4 className="text-muted">Nenhum status registrado.</h4>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListStatus;
